import { Routes, Route } from "react-router-dom";

//Protection of route
import ProtectedRoute from "./components/protected/ProtectedRoute";

//LandingPage
import LandingPage from "./pages/LandingPage";

//Authentication
import Login from "./pages/auth/Login";
import Register from "./pages/auth/Register";

//Dashboard
import Layout from "./components/protected/Layout";
import Dashboard from "./pages/dashboard/Dashboard";
import Profile from "./pages/profile/Profile";

//Application
import Calendar from "./pages/calendars/Calendar";
import Community from "./pages/communities/Community";
import Country from "./pages/countries/Country";
import Donation from "./pages/donations/Donation";
import Donor from "./pages/donors/Donor";
import Help from "./pages/help/Help";
import Messenger from "./pages/messenger/Messenger";

//Projects
import Project from "./pages/projects/Project";

//Project Requests
import MyRequest from "./pages/projectRequests/MyRequest";

import ProjectDetails from "./pages/projects/ProjectDetails";
import Setting from "./pages/settings/Setting";
import Permission from "./pages/permissions/Permission";
import Task from "./pages/tasks/Task";
import User from "./pages/users/User";
import Role from "./pages/roles/Role";

//Reports
import Report from "./pages/reports/Report";
import ProjectReport from "./pages/reports/ProjectReport";
import Nation from "./pages/nation/Nation";
import TaskReport from "./pages/reports/TaskReport";

//
import ForgotPassword from "./pages/auth/ForgotPassword";
import InviteRegister from "./pages/auth/InviteRegister";
// Error page
import PageNotFound from "./pages/error/PageNotFound";
import NotAuthorized from "./pages/error/NotAuthorized";
import ErrorMessage from "./pages/error/ErrorMessage";
import NetworkError from "./pages/error/NetworkError";

//Account Reports
import AccountReport from "./pages/reports/AccountReport";
import CashFlowReport from "./pages/reports/CashFlowReport";
import DonorsReport from "./pages/reports/DonorsReport";
import SingleDonorReport from "./pages/reports/SingleDonorReport";
import ExpenditureVarianceReport from "./pages/reports/ExpenditureVarianceReport";
import IncomeVarianceReport from "./pages/reports/IncomeVarianceReport";
import MonthlyFinancialReport from "./pages/reports/MonthlyFinancialReport";
import VarianceReport from "./pages/reports/VarianceReport";

//Accounts
import Chart from "./pages/chart/Chart";
import ChartReport from "./pages/chart/ChartReport";
import Transaction from "./pages/accounts/Transaction";
import Maintenance from "./pages/accounts/Maintenance";
import AccountReporting from "./pages/accounts/Report";
import ReceiptTransaction from "./pages/accounts/ReceiptTransaction";
import SingleProjectReport from "./pages/reports/SingleProjectReport";
import Pledge from "./pages/pledges/Pledge";
import CreatePledge from "./pages/pledges/CreatePledge";
import Vendor from "./pages/vendors/Vendor";
import CreateVendor from "./pages/vendors/CreateVendor";
import BankReconciliation from "./pages/accounts/BankReconciliation";
import ContractAward from "./pages/accounts/ContractAward";
import CurrencySettings from "./pages/accounts/CurrencySettings";
import DisbursementControlEntry from "./pages/accounts/DisbursementControlEntry";
import LedgerReconciliation from "./pages/accounts/LedgerReconciliation";
import JournalEntry from "./pages/accounts/JournalEntry";
import JournalTransfer from "./pages/accounts/JournalTransfer";
import JournalBatchEntry from "./pages/accounts/JournalBatchEntry";
import FinancialStatement from "./pages/reports/FinancialStatement";
import PaymentTransaction from "./pages/accounts/PaymentTransaction";
import ApplicationReview from "./pages/projectProvincialCouncil/needAssessment/ProvincialReview";
import AddBeneficiaryProfile from "./pages/projectRequests/needsAssessment/AddBeneficiaryProfile";
import AddProblemStatement from "./pages/projectRequests/needsAssessment/AddProblemStatement";
import SuccessfulRequestSubmit from "./pages/projectRequests/needsAssessment/SuccessfulRequestSubmit";
import LocalProjectRequest from "./pages/projectCommunityCouncil/CommunityRequestApproval";
import PDORequestApproval from "./pages/projectPDO/PDORequestApproval";
import ProvincialRequestApproval from "./pages/projectProvincialCouncil/ProvincialRequestApproval";
import ProblemStatementSummary from "./pages/projectRequests/needsAssessment/ProblemStatementSummary";
import EconomerRequestApproval from "./pages/projectEconomer/EconomerRequestApproval";
import CommunityReview from "./pages/projectCommunityCouncil/needAssessment/CommunityReview";
import SuccessfulCommunityApprovalSubmit from "./pages/projectCommunityCouncil/needAssessment/CommunityReviewSubmit";
import ProvincialReview from "./pages/projectProvincialCouncil/needAssessment/ProvincialReview";
import ProvincialReviewSubmit from "./pages/projectProvincialCouncil/needAssessment/ProvincialReviewSubmit";
import PDOReview from "./pages/projectPDO/needAssessment/PDOReview";
import PhaseTwoBegin from "./pages/projectRequests/planning/PhaseTwoBegin";
import ProposalBackground from "./pages/projectRequests/planning/ProposalBackground";
import ProposalBasic from "./pages/projectRequests/planning/ProposalBasic";
import ProposalBudget from "./pages/projectRequests/planning/ProposalBudget";
import ProposalDetails from "./pages/projectRequests/planning/ProposalDetails";
import PDOReviewSubmit from "./pages/projectPDO/needAssessment/PDOReviewSubmit";
import ProposalSubmitState from "./pages/projectRequests/planning/ProposalSubmitState";
import ProposalSummary from "./pages/projectRequests/planning/ProposalSummary";
import ProjectAccount from "./pages/projectAccounts/ProjectAccount";
import CreateProjectAccount from "./pages/projectAccounts/CreateProjectAccount";
import MyProposal from "./pages/projectRequests/MyProposal";
import ProposalIssues from "./pages/projectRequests/planning/ProposalIssues";
import ProvincialProposalReview from "./pages/projectProvincialCouncil/planning/ProvincialProposalReview";
import ProposalReformulation from "./pages/projectReformulation/ProposalReformulation";
import ProjectImplementation from "./pages/projectImplementation/ProjectImplementation";
import ProjectEvaluation from "./pages/projectEvaluation/ProjectEvaluation";
import SingleCommunity from "./pages/communities/SingleCommunity";
import SingleUser from "./pages/users/SingleUser";
import SingleDonor from "./pages/donors/SingleDonor";
import SingleDepartment from "./pages/departments/SingleDepartment";
import Department from "./pages/departments/Department";
import PDOProposalReview from "./pages/projectPDO/planning/PDOProposalReview";
import PDOProposalSubmitState from "./pages/projectPDO/planning/PDOProposalSubmitState";
import Reformulation from "./pages/projectReformulation/Reformulation";
import CommunityProposalReview from "./pages/projectCommunityCouncil/planning/CommunityProposalReview";
import CommunityProposalSubmitState from "./pages/projectCommunityCouncil/planning/CommunityProposalSubmitState";
import CanceledProjects from "./pages/canceledProjects/CanceledProjects";
import SingleCanceledProject from "./pages/canceledProjects/SingleCanceledProject";
import ManageProjects from "./pages/projectManagement/ManageProjects";
import ManageSingleProject from "./pages/projectManagement/ManageSingleProject";
import ProvincialReports from "./pages/projectProvincialCouncil/ProvincialReports";
import PDOReports from "./pages/projectPDO/PDOReports";
import CommunityReports from "./pages/projectCommunityCouncil/CommunityReports";
import ReformulationDonor from "./pages/projectReformulation/ReformulationDonor";
import NewPassword from "./pages/auth/NewPassword";
import ProjectFollowUpList from "./pages/projectReformulation/followUp/ProjectFollowUpList";
import DonorProposalFollowUp from "./pages/projectReformulation/followUp/DonorProposalFollowUp";
import ProjectAgreements from "./pages/projectReformulation/agreements/ProjectAgreements";
import SingleCurrency from "./pages/currencies/SingleCurrency";
import Currency from "./pages/currencies/Currency";
import MethodType from "./pages/transMethodTypes/MethodType";
import SingleMethodType from "./pages/transMethodTypes/SingleMethodType";
import ChartAccount from "./pages/chart/accounts/ChartAccount";
import SingleChartAccount from "./pages/chart/accounts/SingleChartAccount";
import ChartCategory from "./pages/chart/categories/ChartCategory";
import SingleChartCategory from "./pages/chart/categories/SingleChartCategory";
import SingleNation from "./pages/nation/SingleNation";

function App() {
  return (
    <>
      <Routes>
        <Route index element={<LandingPage />} />
        <Route path="/registeringsuper" element={<Register />} />
        <Route path="/register/:token" element={<InviteRegister />} />
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/new-password/:token" element={<NewPassword />} />
        <Route path="/error" element={<ErrorMessage />} />
        <Route path="/" element={<Layout />}>
          {/* Not Authorized */}
          <Route path="/network-error" element={<NetworkError />} />
          <Route
            path="/not-authorized"
            element={
              <ProtectedRoute roles={{ resource: "dashboard", action: "read" }}>
                <NotAuthorized />
              </ProtectedRoute>
            }
          />
          {/* Layout Start,DAshboard Page */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute roles={{ resource: "dashboard", action: "read" }}>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/profile"
            element={
              <ProtectedRoute roles={{ resource: "dashboard", action: "read" }}>
                <Profile />
              </ProtectedRoute>
            }
          />

          {/* Projects Request */}
          <Route
            path="/requests/my-requests"
            element={
              <ProtectedRoute roles={{ resource: "projects", action: "read" }}>
                <MyRequest />
              </ProtectedRoute>
            }
          />
          <Route
            path="/requests/beneficiary-profile"
            element={
              <ProtectedRoute
                roles={{ resource: "projects", action: "update" }}
              >
                <AddBeneficiaryProfile />
              </ProtectedRoute>
            }
          />
          <Route
            path="/requests/beneficiary-profile/:id"
            element={
              <ProtectedRoute
                roles={{ resource: "projects", action: "update" }}
              >
                <AddBeneficiaryProfile />
              </ProtectedRoute>
            }
          />
          <Route
            path="/requests/problem-statement/:id"
            element={
              <ProtectedRoute
                roles={{ resource: "projects", action: "update" }}
              >
                <AddProblemStatement />
              </ProtectedRoute>
            }
          />
          <Route
            path="/requests/problem-statement-summary/:id"
            element={
              <ProtectedRoute
                roles={{ resource: "projects", action: "update" }}
              >
                <ProblemStatementSummary />
              </ProtectedRoute>
            }
          />

          <Route
            path="/requests/problem-statement/success/:id"
            element={
              <ProtectedRoute
                roles={{ resource: "projects", action: "update" }}
              >
                <SuccessfulRequestSubmit />
              </ProtectedRoute>
            }
          />

          {/* Project  Proposal */}

          <Route
            path="/projects/proposals"
            element={
              <ProtectedRoute
                roles={{ resource: "pdo_department", action: "read" }}
              >
                <MyProposal />
              </ProtectedRoute>
            }
          />
          <Route
            path="/requests/phase-two/:id"
            element={
              <ProtectedRoute
                roles={{ resource: "pdo_department", action: "update" }}
              >
                <PhaseTwoBegin />
              </ProtectedRoute>
            }
          />
          <Route
            path="/proposals/phase-two/:id"
            element={
              <ProtectedRoute
                roles={{ resource: "pdo_department", action: "update" }}
              >
                <PhaseTwoBegin />
              </ProtectedRoute>
            }
          />
          <Route
            path="/proposals/basics/:id"
            element={
              <ProtectedRoute
                roles={{ resource: "pdo_department", action: "update" }}
              >
                <ProposalBasic />
              </ProtectedRoute>
            }
          />

          <Route
            path="/proposals/background/:id"
            element={
              <ProtectedRoute
                roles={{ resource: "pdo_department", action: "update" }}
              >
                <ProposalBackground />
              </ProtectedRoute>
            }
          />

          <Route
            path="/proposals/details/:id"
            element={
              <ProtectedRoute
                roles={{ resource: "pdo_department", action: "update" }}
              >
                <ProposalDetails />
              </ProtectedRoute>
            }
          />

          <Route
            path="/proposals/issues/:id"
            element={
              <ProtectedRoute
                roles={{ resource: "pdo_department", action: "update" }}
              >
                <ProposalIssues />
              </ProtectedRoute>
            }
          />

          <Route
            path="/proposals/budget/:id"
            element={
              <ProtectedRoute
                roles={{ resource: "pdo_department", action: "update" }}
              >
                <ProposalBudget />
              </ProtectedRoute>
            }
          />

          <Route
            path="/proposals/summary/:id"
            element={
              <ProtectedRoute
                roles={{ resource: "pdo_department", action: "update" }}
              >
                <ProposalSummary />
              </ProtectedRoute>
            }
          />

          <Route
            path="/proposal/success/:id"
            element={
              <ProtectedRoute
                roles={{ resource: "pdo_department", action: "update" }}
              >
                <ProposalSubmitState />
              </ProtectedRoute>
            }
          />

          {/* Proposal Reformulation */}
          <Route
            path="/projects/reformulations"
            element={
              <ProtectedRoute
                roles={{ resource: "reformulation", action: "read" }}
              >
                <ProposalReformulation />
              </ProtectedRoute>
            }
          />
          <Route
            path="/reformulations/:id"
            element={
              <ProtectedRoute
                roles={{ resource: "reformulation", action: "read" }}
              >
                <Reformulation />
              </ProtectedRoute>
            }
          />
          <Route
            path="/reformulations/donors/:id/:project_id"
            element={
              <ProtectedRoute
                roles={{ resource: "reformulation", action: "read" }}
              >
                <ReformulationDonor />
              </ProtectedRoute>
            }
          />
          {/*  */}
          <Route
            path="/reformulations/emails/follow-up/:id"
            element={
              <ProtectedRoute
                roles={{ resource: "reformulation", action: "read" }}
              >
                <ProjectFollowUpList />
              </ProtectedRoute>
            }
          />
          <Route
            path="/reformulations/donors/follow-up/:donor_id/:project_id"
            element={
              <ProtectedRoute
                roles={{ resource: "reformulation", action: "read" }}
              >
                <DonorProposalFollowUp />
              </ProtectedRoute>
            }
          />
          <Route
            path="/projects/implementations/add-agreements/:id"
            element={
              <ProtectedRoute
                roles={{ resource: "reformulation", action: "read" }}
              >
                <ProjectAgreements />
              </ProtectedRoute>
            }
          />

          {/* Project Implementation*/}

          <Route
            path="/projects/implementations"
            element={
              <ProtectedRoute
                roles={{ resource: "implementation", action: "read" }}
              >
                <ProjectImplementation />
              </ProtectedRoute>
            }
          />
          {/* Project Evaluation */}
          <Route
            path="/projects/evaluations"
            element={
              <ProtectedRoute
                roles={{ resource: "evaluation", action: "read" }}
              >
                <ProjectEvaluation />
              </ProtectedRoute>
            }
          />
          {/* Project Manager */}
          <Route
            path="/projects/manage"
            element={
              <ProtectedRoute
                roles={{ resource: "manage_projects", action: "read" }}
              >
                <ManageProjects />
              </ProtectedRoute>
            }
          />
          <Route
            path="/projects/manage/:id"
            element={
              <ProtectedRoute
                roles={{ resource: "manage_projects", action: "read" }}
              >
                <ManageSingleProject />
              </ProtectedRoute>
            }
          />
          {/* Canceled Project */}
          <Route
            path="/projects/canceled-projects"
            element={
              <ProtectedRoute roles={{ resource: "projects", action: "read" }}>
                <CanceledProjects />
              </ProtectedRoute>
            }
          />
          <Route
            path="/projects/canceled-projects/:id"
            element={
              <ProtectedRoute roles={{ resource: "projects", action: "read" }}>
                <SingleCanceledProject />
              </ProtectedRoute>
            }
          />

          {/* Community Council Approvals */}

          <Route
            path="/requests/community-approvals"
            element={
              <ProtectedRoute
                roles={{ resource: "community_council", action: "read" }}
              >
                <LocalProjectRequest />
              </ProtectedRoute>
            }
          />
          {/* Community Requests */}
          <Route
            path="/requests/community-approval/:id"
            element={
              <ProtectedRoute
                roles={{ resource: "community_council", action: "read" }}
              >
                <CommunityReview />
              </ProtectedRoute>
            }
          />
          <Route
            path="/requests/community-approval/success/:id"
            element={
              <ProtectedRoute
                roles={{ resource: "community_council", action: "read" }}
              >
                <SuccessfulCommunityApprovalSubmit />
              </ProtectedRoute>
            }
          />
          <Route
            path="/requests/community-approval/canceled/:id"
            element={
              <ProtectedRoute
                roles={{ resource: "community_council", action: "read" }}
              >
                <SuccessfulCommunityApprovalSubmit />
              </ProtectedRoute>
            }
          />
          {/* Community Proposals */}
          <Route
            path="/proposals/community-approval/:id"
            element={
              <ProtectedRoute
                roles={{ resource: "community_council", action: "read" }}
              >
                <CommunityProposalReview />
              </ProtectedRoute>
            }
          />
          <Route
            path="/proposals/community-approval/success/:id"
            element={
              <ProtectedRoute
                roles={{ resource: "community_council", action: "read" }}
              >
                <CommunityProposalSubmitState />
              </ProtectedRoute>
            }
          />
          <Route
            path="/proposals/community-approval/canceled/:id"
            element={
              <ProtectedRoute
                roles={{ resource: "community_council", action: "read" }}
              >
                <CommunityProposalSubmitState />
              </ProtectedRoute>
            }
          />
          <Route
            path="/projects/community/reports"
            element={
              <ProtectedRoute
                roles={{ resource: "community_council", action: "read" }}
              >
                <CommunityReports />
              </ProtectedRoute>
            }
          />
          {/* PDO Approvals */}
          <Route
            path="/requests/pdo-approvals"
            element={
              <ProtectedRoute
                roles={{ resource: "pdo_department", action: "read" }}
              >
                <PDORequestApproval />
              </ProtectedRoute>
            }
          />
          {/* PDO Request Approvals */}
          <Route
            path="/requests/pdo-approval/:id"
            element={
              <ProtectedRoute
                roles={{ resource: "pdo_department", action: "read" }}
              >
                <PDOReview />
              </ProtectedRoute>
            }
          />
          <Route
            path="/requests/pdo-approval/success/:id"
            element={
              <ProtectedRoute
                roles={{ resource: "pdo_department", action: "read" }}
              >
                <PDOReviewSubmit />
              </ProtectedRoute>
            }
          />
          <Route
            path="/requests/pdo-approval/cancel/:id"
            element={
              <ProtectedRoute
                roles={{ resource: "pdo_department", action: "read" }}
              >
                <PDOReviewSubmit />
              </ProtectedRoute>
            }
          />
          {/* PDO Proposal Approvals */}
          <Route
            path="/proposals/pdo-approval/:id"
            element={
              <ProtectedRoute
                roles={{ resource: "pdo_department", action: "read" }}
              >
                <PDOProposalReview />
              </ProtectedRoute>
            }
          />
          {/* PDO Proposal */}
          <Route
            path="/proposals/pdo-approval/success/:id"
            element={
              <ProtectedRoute
                roles={{ resource: "pdo_department", action: "read" }}
              >
                <PDOProposalSubmitState />
              </ProtectedRoute>
            }
          />
          <Route
            path="/proposals/pdo-approval/cancel/:id"
            element={
              <ProtectedRoute
                roles={{ resource: "pdo_department", action: "read" }}
              >
                <PDOProposalSubmitState />
              </ProtectedRoute>
            }
          />
          <Route
            path="/projects/pdo/reports"
            element={
              <ProtectedRoute
                roles={{ resource: "pdo_department", action: "read" }}
              >
                <PDOReports />
              </ProtectedRoute>
            }
          />

          {/* Provincial Council approvals */}
          <Route
            path="/requests/provincial-approvals"
            element={
              <ProtectedRoute
                roles={{ resource: "provincial_council", action: "read" }}
              >
                <ProvincialRequestApproval />
              </ProtectedRoute>
            }
          />
          <Route
            path="/requests/provincial-approval/:id"
            element={
              <ProtectedRoute
                roles={{ resource: "provincial_council", action: "read" }}
              >
                <ProvincialReview />
              </ProtectedRoute>
            }
          />
          <Route
            path="/proposals/provincial-approval/:id"
            element={
              <ProtectedRoute
                roles={{ resource: "provincial_council", action: "read" }}
              >
                <ProvincialProposalReview />
              </ProtectedRoute>
            }
          />
          <Route
            path="/requests/provincial-approval/success/:id"
            element={
              <ProtectedRoute
                roles={{ resource: "provincial_council", action: "read" }}
              >
                <ProvincialReviewSubmit />
              </ProtectedRoute>
            }
          />
          <Route
            path="/requests/provincial-approval/canceled/:id"
            element={
              <ProtectedRoute
                roles={{ resource: "provincial_council", action: "read" }}
              >
                <ProvincialReviewSubmit />
              </ProtectedRoute>
            }
          />
          <Route
            path="/projects/provincial/reports"
            element={
              <ProtectedRoute
                roles={{ resource: "provincial_council", action: "read" }}
              >
                <ProvincialReports />
              </ProtectedRoute>
            }
          />

          {/* Accounts approvals */}

          <Route
            path="/projects/accounts"
            element={
              <ProtectedRoute roles={{ resource: "accounts", action: "read" }}>
                <ProjectAccount />
              </ProtectedRoute>
            }
          />

          <Route
            path="/projects/accounts/create/:id"
            element={
              <ProtectedRoute roles={{ resource: "accounts", action: "read" }}>
                <CreateProjectAccount />
              </ProtectedRoute>
            }
          />

          {/* Economer approvals */}
          <Route
            path="/requests/economer-approvals"
            element={
              <ProtectedRoute roles={{ resource: "ecomomer", action: "read" }}>
                <EconomerRequestApproval />
              </ProtectedRoute>
            }
          />
          <Route
            path="/request-manager/application-review"
            element={
              <ProtectedRoute roles={{ resource: "projects", action: "read" }}>
                <ApplicationReview />
              </ProtectedRoute>
            }
          />

          {/* Projects */}
          <Route
            path="/projects"
            element={
              <ProtectedRoute roles={{ resource: "projects", action: "read" }}>
                <Project />
              </ProtectedRoute>
            }
          />
          <Route
            path="/project-requests"
            element={
              <ProtectedRoute roles={{ resource: "projects", action: "read" }}>
                <Project />
              </ProtectedRoute>
            }
          />

          {/* Project Old Files */}

          <Route
            path="/projects/implementation/:id"
            element={
              <ProtectedRoute
                roles={{ resource: "implementation", action: "read" }}
              >
                <ProjectDetails />
              </ProtectedRoute>
            }
          />

          {/* Calendar */}
          <Route
            path="/calendar"
            element={
              <ProtectedRoute roles={{ resource: "dashboard", action: "read" }}>
                <Calendar />
              </ProtectedRoute>
            }
          />

          {/* Tasks */}
          <Route
            path="/tasks/:id"
            element={
              <ProtectedRoute roles={{ resource: "tasks", action: "read" }}>
                <Task />
              </ProtectedRoute>
            }
          />

          {/* Countries */}
          <Route
            path="/countries"
            element={
              <ProtectedRoute roles={{ resource: "countries", action: "read" }}>
                <Country />
              </ProtectedRoute>
            }
          />

          {/* Communities */}

          <Route
            path="/communities"
            element={
              <ProtectedRoute
                roles={{ resource: "communities", action: "read" }}
              >
                <Community />
              </ProtectedRoute>
            }
          />
          <Route
            path="/communities/:id"
            element={
              <ProtectedRoute
                roles={{ resource: "communities", action: "read" }}
              >
                <SingleCommunity />
              </ProtectedRoute>
            }
          />

          {/* Accounts */}

          <Route
            path="/accounts/transaction"
            element={
              <ProtectedRoute roles={{ resource: "accounts", action: "read" }}>
                <Transaction />
              </ProtectedRoute>
            }
          />
          <Route
            path="/accounts/maintenance"
            element={
              <ProtectedRoute roles={{ resource: "accounts", action: "read" }}>
                <Maintenance />
              </ProtectedRoute>
            }
          />
          <Route
            path="/accounts/report"
            element={
              <ProtectedRoute roles={{ resource: "accounts", action: "read" }}>
                <AccountReporting />
              </ProtectedRoute>
            }
          />
          <Route
            path="/accounts/bank-reconciliation"
            element={
              <ProtectedRoute roles={{ resource: "accounts", action: "read" }}>
                <BankReconciliation />
              </ProtectedRoute>
            }
          />
          <Route
            path="/accounts/contract-award"
            element={
              <ProtectedRoute roles={{ resource: "accounts", action: "read" }}>
                <ContractAward />
              </ProtectedRoute>
            }
          />
          <Route
            path="/accounts/currency-settings"
            element={
              <ProtectedRoute roles={{ resource: "accounts", action: "read" }}>
                <CurrencySettings />
              </ProtectedRoute>
            }
          />
          <Route
            path="/accounts/disbursement-control"
            element={
              <ProtectedRoute roles={{ resource: "accounts", action: "read" }}>
                <DisbursementControlEntry />
              </ProtectedRoute>
            }
          />
          <Route
            path="/accounts/ledger-reconciliation"
            element={
              <ProtectedRoute roles={{ resource: "accounts", action: "read" }}>
                <LedgerReconciliation />
              </ProtectedRoute>
            }
          />

          {/* Account  */}
          <Route
            path="/settings/accounts"
            element={
              <ProtectedRoute roles={{ resource: "accounts", action: "read" }}>
                <ChartAccount />
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings/accounts/:id"
            element={
              <ProtectedRoute roles={{ resource: "accounts", action: "read" }}>
                <SingleChartAccount />
              </ProtectedRoute>
            }
          />

          {/* Account  */}
          <Route
            path="/settings/account-categories"
            element={
              <ProtectedRoute roles={{ resource: "accounts", action: "read" }}>
                <ChartCategory />
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings/account-categories/:id"
            element={
              <ProtectedRoute roles={{ resource: "accounts", action: "read" }}>
                <SingleChartCategory />
              </ProtectedRoute>
            }
          />

          {/* Account Receipt */}
          <Route
            path="/accounts/receipts"
            element={
              <ProtectedRoute roles={{ resource: "accounts", action: "read" }}>
                <ReceiptTransaction />
              </ProtectedRoute>
            }
          />
          {/* Account Receipt */}
          <Route
            path="/accounts/payments"
            element={
              <ProtectedRoute roles={{ resource: "accounts", action: "read" }}>
                <PaymentTransaction />
              </ProtectedRoute>
            }
          />

          {/* Account Journal */}
          <Route
            path="/accounts/journal-entry"
            element={
              <ProtectedRoute roles={{ resource: "accounts", action: "read" }}>
                <JournalEntry />
              </ProtectedRoute>
            }
          />
          <Route
            path="/accounts/journal-transfer"
            element={
              <ProtectedRoute roles={{ resource: "accounts", action: "read" }}>
                <JournalTransfer />
              </ProtectedRoute>
            }
          />
          <Route
            path="/accounts/journal-batch-entry"
            element={
              <ProtectedRoute roles={{ resource: "accounts", action: "read" }}>
                <JournalBatchEntry />
              </ProtectedRoute>
            }
          />

          {/* Pledges */}
          <Route
            path="/pledges"
            element={
              <ProtectedRoute roles={{ resource: "accounts", action: "read" }}>
                <Pledge />
              </ProtectedRoute>
            }
          />
          <Route
            path="/pledges/create-pledge"
            element={
              <ProtectedRoute roles={{ resource: "accounts", action: "read" }}>
                <CreatePledge />
              </ProtectedRoute>
            }
          />

          {/* Vendors */}
          <Route
            path="/vendors"
            element={
              <ProtectedRoute roles={{ resource: "accounts", action: "read" }}>
                <Vendor />
              </ProtectedRoute>
            }
          />
          <Route
            path="/vendors/create-vendor"
            element={
              <ProtectedRoute roles={{ resource: "accounts", action: "read" }}>
                <CreateVendor />
              </ProtectedRoute>
            }
          />

          {/* Reports */}
          <Route
            path="/reports"
            element={
              <ProtectedRoute
                roles={{ resource: "project_reports", action: "read" }}
              >
                <Report />
              </ProtectedRoute>
            }
          />
          <Route
            path="/project-reports"
            element={
              <ProtectedRoute
                roles={{ resource: "project_reports", action: "read" }}
              >
                <ProjectReport />
              </ProtectedRoute>
            }
          />
          <Route
            path="/project-reports/:id"
            element={
              <ProtectedRoute
                roles={{ resource: "project_reports", action: "read" }}
              >
                <SingleProjectReport />
              </ProtectedRoute>
            }
          />
          {/* Accounts Report */}
          <Route
            path="/reports/account-report"
            element={
              <ProtectedRoute
                roles={{ resource: "account_reports", action: "read" }}
              >
                <AccountReport />
              </ProtectedRoute>
            }
          />
          <Route
            path="/reports/cash-flow-report"
            element={
              <ProtectedRoute
                roles={{ resource: "account_reports", action: "read" }}
              >
                <CashFlowReport />
              </ProtectedRoute>
            }
          />
          <Route
            path="/reports/financial-statement"
            element={
              <ProtectedRoute
                roles={{ resource: "account_reports", action: "read" }}
              >
                <FinancialStatement />
              </ProtectedRoute>
            }
          />
          <Route
            path="/reports/donors-report"
            element={
              <ProtectedRoute
                roles={{ resource: "account_reports", action: "read" }}
              >
                <DonorsReport />
              </ProtectedRoute>
            }
          />
          <Route
            path="/reports/donors-report/:id"
            element={
              <ProtectedRoute
                roles={{ resource: "account_reports", action: "read" }}
              >
                <SingleDonorReport />
              </ProtectedRoute>
            }
          />
          <Route
            path="/reports/expenditure-variance-report"
            element={
              <ProtectedRoute
                roles={{ resource: "account_reports", action: "read" }}
              >
                <ExpenditureVarianceReport />
              </ProtectedRoute>
            }
          />
          <Route
            path="/reports/income-variance-report"
            element={
              <ProtectedRoute
                roles={{ resource: "account_reports", action: "read" }}
              >
                <IncomeVarianceReport />
              </ProtectedRoute>
            }
          />
          <Route
            path="/reports/monthly-financial-report"
            element={
              <ProtectedRoute
                roles={{ resource: "account_reports", action: "read" }}
              >
                <MonthlyFinancialReport />
              </ProtectedRoute>
            }
          />
          <Route
            path="/reports/variance-report"
            element={
              <ProtectedRoute
                roles={{ resource: "account_reports", action: "read" }}
              >
                <VarianceReport />
              </ProtectedRoute>
            }
          />
          <Route
            path="/"
            element={
              <ProtectedRoute
                roles={{ resource: "account_reports", action: "read" }}
              >
                <AccountReport />
              </ProtectedRoute>
            }
          />

          {/* Settings */}
          <Route
            path="/settings"
            element={
              <ProtectedRoute roles={{ resource: "roles", action: "read" }}>
                <Setting />
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings/nations"
            element={
              <ProtectedRoute roles={{ resource: "countries", action: "read" }}>
                <Nation />
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings/nations/:id"
            element={
              <ProtectedRoute roles={{ resource: "countries", action: "read" }}>
                <SingleNation />
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings/chart"
            element={
              <ProtectedRoute roles={{ resource: "accounts", action: "read" }}>
                <Chart />
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings/chart-report"
            element={
              <ProtectedRoute roles={{ resource: "accounts", action: "read" }}>
                <ChartReport />
              </ProtectedRoute>
            }
          />
          {/* Permissions */}
          <Route
            path="/settings/permissions/:id"
            element={
              <ProtectedRoute
                roles={{ resource: "permissions", action: "read" }}
              >
                <Permission />
              </ProtectedRoute>
            }
          />
          {/* Role */}
          <Route
            path="/settings/roles"
            element={
              <ProtectedRoute roles={{ resource: "roles", action: "read" }}>
                <Role />
              </ProtectedRoute>
            }
          />

          {/* Donation */}
          <Route
            path="/donations"
            element={
              <ProtectedRoute roles={{ resource: "donations", action: "read" }}>
                <Donation />
              </ProtectedRoute>
            }
          />
          {/* Donors */}
          <Route
            path="/settings/donors"
            element={
              <ProtectedRoute roles={{ resource: "donors", action: "read" }}>
                <Donor />
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings/donors/:id"
            element={
              <ProtectedRoute roles={{ resource: "donors", action: "read" }}>
                <SingleDonor />
              </ProtectedRoute>
            }
          />
          {/* Currencies */}
          <Route
            path="/settings/currencies"
            element={
              <ProtectedRoute roles={{ resource: "settings", action: "read" }}>
                <Currency />
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings/currencies/:id"
            element={
              <ProtectedRoute roles={{ resource: "settings", action: "read" }}>
                <SingleCurrency />
              </ProtectedRoute>
            }
          />

          {/* Method Types */}
          <Route
            path="/settings/method-types"
            element={
              <ProtectedRoute roles={{ resource: "settings", action: "read" }}>
                <MethodType />
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings/method-types/:id"
            element={
              <ProtectedRoute roles={{ resource: "settings", action: "read" }}>
                <SingleMethodType />
              </ProtectedRoute>
            }
          />

          {/* Departments */}
          <Route
            path="/settings/departments"
            element={
              <ProtectedRoute
                roles={{ resource: "departments", action: "read" }}
              >
                <Department />
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings/departments/:id"
            element={
              <ProtectedRoute
                roles={{ resource: "departments", action: "read" }}
              >
                <SingleDepartment />
              </ProtectedRoute>
            }
          />

          {/* Users */}
          <Route
            path="/users"
            element={
              <ProtectedRoute roles={{ resource: "users", action: "read" }}>
                <User />
              </ProtectedRoute>
            }
          />
          <Route
            path="/users/:id"
            element={
              <ProtectedRoute roles={{ resource: "users", action: "read" }}>
                <SingleUser />
              </ProtectedRoute>
            }
          />

          {/* Messenger */}
          <Route
            path="/messenger"
            element={
              <ProtectedRoute roles={{ resource: "dashboard", action: "read" }}>
                <Messenger />
              </ProtectedRoute>
            }
          />

          {/* Heil */}
          <Route
            path="/help"
            element={
              <ProtectedRoute roles={{ resource: "dashboard", action: "read" }}>
                <Help />
              </ProtectedRoute>
            }
          />

          {/* Layout End */}
        </Route>
        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </>
  );
}

export default App;
